import {useState} from 'react';
import {useSelector} from 'react-redux';
import {I18n} from 'react-redux-i18n';

import config from '../../../../../config';

import {recordGAEvent} from '../../../../utils/analytics';

import AccessPandaModal from './AccessPandaModal';
import {pathResolver} from '../../../../utils/basePathHelper';

const PANDA_ACCESSED = 'PANDA_ACCESSED';

const pandaIcon = <img
  alt="icon panda"
  src={pathResolver('resources/img/icon_panda-round.png')}
  style={{width: '100%'}}
/>;

function gaEventOpenedModal() {
  recordGAEvent('PanDa', 'Opened PanDa modal from sidebar menu');
}

function gaEventDismissedModal() {
  recordGAEvent('PanDa', 'Dismissed PanDa modal from sidebar menu');
}

function gaEventAccessPanDa() {
  recordGAEvent('PanDa', 'Accessed PanDa from sidebar menu');
}

function buildPandaUrl(organisation) {
  const organisationId = organisation?.organisationId;
  const state = {};
  if (organisationId) {
    state.ofaOrganisationId = organisationId;
  }
  return `${config.ssoPanDaURL}&state=${encodeURI(JSON.stringify(state))}`;
}

function AccessPandaButton() {
  const organisation = useSelector(globalState => globalState.organisation);
  const [showModal, setShowModal] = useState(false);
  if (!config?.featureFlags?.showAccessPandaButton) { return null; }

  const urlToPanda = buildPandaUrl(organisation);

  function openModal() {
    gaEventOpenedModal();
    setShowModal(true);
  }

  function closeModal() {
    gaEventDismissedModal();
    setShowModal(false);
  }

  function handleConfirm() {
    gaEventAccessPanDa();
    localStorage.setItem(PANDA_ACCESSED, 'true');
    setShowModal(false);
  }

  if (localStorage.getItem(PANDA_ACCESSED)) {
    return (
      <a
        target="_blank"
        onClick={gaEventAccessPanDa}
        href={urlToPanda}
        className="button-square px-1 flex-container"
        rel="noopener noreferrer"
        title={I18n.t('menu.panda')}
      >
        {pandaIcon}
      </a>
    );
  }

  return (
    <>
      <button
        onClick={openModal}
        className="button-square px-1 flex-container"
        title={I18n.t('menu.panda')}
      >
        {pandaIcon}
      </button>
      <AccessPandaModal
        isOpen={showModal}
        onClose={closeModal}
        onConfirm={handleConfirm}
        urlToPanda={urlToPanda}
      />
    </>
  );
}

export default AccessPandaButton;
